module.exports = __webpack_public_path__ + "media/images/logos/logo-glin-slogan-white-3b844bb71df4aeebb4e2d375e3a8a125.svg";